import 'src/lib/sentry';
import '@fontsource-variable/dm-sans';
import '@fontsource/dm-serif-display';
import '@fontsource/dm-serif-display/400-italic.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import App from './app';
import { routesSection } from './routes/sections';
import { ErrorBoundary } from './routes/components';
import { VerifiedAddressProvider } from "./lib/VerifiedAddressContext";


// ----------------------------------------------------------------------

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

const root = createRoot(document.getElementById('root')!);

root.render(
  <StrictMode>
    <VerifiedAddressProvider>
      <RouterProvider router={router} />
    </VerifiedAddressProvider>
  </StrictMode>
);
